import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import AccEditarImagen from "./../../../assets/EditarImagen.svg";
import { Col, Row } from "react-bootstrap";
import { useState } from "react";
import { useEffect } from "react";
import Modal from "../../../Includes/Modal";
import { CargarImagenEdit } from "../Funciones/CargarImagen";
import { IMG } from "../../Funciones Generales/Constantes";
import { styled } from "@mui/material/styles";

const extenciones = ["webp", "png", "jpg", "jpeg"]


const ModalCargarMultImagen = ({
  id = 0,
  tipo = "",
  Titulo = "Cargar imagen",
  mostrar = false,
  fnCerrar = () => { },
  fnDevolverImagen = (src) => { },
  getTotalImgs = () => { },
  maximoImagenes = 10,
}) => {
  const [error, setError] = useState({
    mostrar: false,
    mensaje: "",
    severity: "error",
  });


  const [isLoading, setLoading] = useState(false)
  const [arrImgs, setArrImgs] = useState([]);

  const isValidoAzureStorage = () => {
    let validarTipo = false;
    Object.keys(IMG).map((tipoImagen) => {
      if (IMG[tipoImagen] == tipo) {
        validarTipo = true;
      }
    });
    return validarTipo
  }

  const getRandomId = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });


  const onDrop = useCallback((files) => {

    if (files) {
      setLoading(true)

      console.log(files.length, maximoImagenes, getTotalImgs())

      if (files.length > 0 && files.length <= maximoImagenes - getTotalImgs()) {
        let newArr = arrImgs.filter((item) => item);
        let error = false;
        files.map(async (item, i) => {

          const data = await toBase64(item)
          const dataImg64 = data.split("base64,");
          const dataImgType = dataImg64[0].split("/")[1].replace(";", "").trim()

          if (!error) {
            error = extenciones.includes(dataImgType) ? false : true
          }
          newArr.push({ ID: getRandomId(1, 100000000), IMG: data });

          if (i == (files.length - 1)) {
            if (!error) {
              setArrImgs([...newArr]);
            } else {
              setError({
                mostrar: true,
                mensaje: `Los archivos permitidos son (${extenciones.toString().replaceAll(",", " ,")})`,
                severity: "error",
              });
              setLoading(false)
            }
          }
        });

      } else {
        setLoading(false)
        setError({
          mostrar: true,
          mensaje: `Maximo de imagenes superado (${maximoImagenes})`,
          severity: "error",
        });
      }

    }
  }, []);

  const EnviarImagenApi = (index, numImagenEnviar, totalImages, arrURLS) => {

    console.log(" ENVIANDO : " + index + " de " + numImagenEnviar)
    if (index <= numImagenEnviar) {

      const principal = totalImages == 0 ? (index == 1 ? true : false) : false;
      const img_64 = arrImgs[index - 1].IMG.split("base64,")[1];

      CargarImagenEdit(id, tipo, img_64, principal)
        .then((resp) => {
          EnviarImagenApi(index + 1, numImagenEnviar, totalImages, [
            ...arrURLS,
            {
              ID: resp.respuesta.id,
              IMG: resp.respuesta.url
            }
          ])
        })
        .catch((resp) => {          
          setError({
            mostrar: true,
            mensaje: resp.mensaje,
            severity: "error",
          });
          EnviarImagenApi(index + 1, numImagenEnviar, totalImages, arrURLS)
        })
    } else {

      setTimeout(() => {
        fnDevolverImagen(arrURLS);
        fnCerrar();
      }, 1000)

    }


  }


  useEffect(() => {

    if (!isValidoAzureStorage()) {
      setError({
        mostrar: true,
        mensaje: "Falta asignar el tipo de la imagen",
        severity: "error",
      });
      return;
    }

    if (isLoading) {

      let arrURLS = [];
      if (id && id != 0) {
        EnviarImagenApi(1, arrImgs.length, getTotalImgs(), [])
      } else {
        const arrayImagenes = arrImgs.map(x => x.IMG)
        fnDevolverImagen(arrayImagenes);
        fnCerrar();
      }
    }


  }, [arrImgs])



  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    onDrop: onDrop,
    accept: {
      "image/webp": [],
      "image/jpg": [],
      "image/jpeg": [],
      "image/png": [],
    },
    maxFiles: 10,
  });

  const StyledSnackbar = styled((props) => <Snackbar {...props} />)(
    ({ theme }) => ({
      "& .MuiSnackbar-root": {
        top: theme.spacing(15),
      },
    })
  );

  return (
    <>
      <Modal
        Titulo={Titulo}
        mostrar={mostrar}
        fnCerrar={fnCerrar}
        maxWidth="md"
        textoGuardar=""
        textoCancelar=""
      >
        <div
          {...getRootProps()}
          style={{ border: "1px dotted lightgray" }}
          className="p-3 mt-0 mb-4 mx-4"
        >
          <input {...getInputProps()} />
          {
            <Row className="p-4 w-100 h-100">
              <Col sm={6} md={4} className="d-flex justify-content-center">
                <img
                  src={AccEditarImagen}
                  className="img-fluid"
                />
              </Col>
              <Col sm={6} md={8}>
                <div className="w-100 h-100 d-flex">
                  <div className="m-auto">
                    <strong> Selecciona la imagen </strong>
                    <p className="text-mutted mb-0">
                      Arrastra la imagen o{" "}
                      <strong style={{ color: "#3ABE88" }}> selecciona</strong>{" "}
                      <br />
                      desde tu ordenador
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          }
        </div>
        {fileRejections && fileRejections.length != 0 && (
          <div className="alert alert-danger py-4 mx-4" role="alert">
            <strong> Error al cargar: </strong>{" "}
            {fileRejections[0].errors[0].message == "Too many files"
              ? "Demasiados archivos"
              : "Solo se aceptan archivos JPG / JPGE / PNG / WEBP /"}
          </div>
        )}
      </Modal>

      <Backdrop sx={{ color: "#fff", zIndex: 1000000 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <StyledSnackbar
        direction="right"
        open={error.mostrar}
        autoHideDuration={6000}
        onClose={() => setError({ ...error, mostrar: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setError({ ...error, mostrar: false })}
          severity={error.severity}
          sx={{ width: "100%" }}
        >
          {error.mensaje}
        </Alert>
      </StyledSnackbar>
    </>
  );
};

export default ModalCargarMultImagen;
